import QueryFetchStatus from "types/QueryFetchStatus";
import { MdErrorOutline, MdRefresh } from "react-icons/md";
import { LoadingContainer } from "../shared/CircularProgressIndicator";
import { Button } from "@components/ui/button";

interface QueryFetchStatePageProps {
  queryFetchStatus: QueryFetchStatus;
  children: React.ReactNode;
  onRetry?: () => void;
  loadingLabel?: string;
  loadingProps?: Omit<Parameters<typeof LoadingContainer>[0], "label">;
}
function QueryFetchStatePage({
  children,
  queryFetchStatus,
  onRetry,
  loadingLabel,
  loadingProps,
}: QueryFetchStatePageProps) {
  switch (queryFetchStatus) {
    case "pending":
      return <LoadingContainer {...loadingProps} label={loadingLabel} />;
    case "error":
      console.error("[QueryFetchStatePage] A query is in error state. Rendering children anyway.");
      return <>{children}</>;
    case "success":
      return <>{children}</>;
  }
}

export default QueryFetchStatePage;
